export default "__VITE_PUBLIC_ASSET__3b20e41f__"